import {CustomerPicker} from './customerPicker';
import {TpvDialog} from '../../../components/TpvDialog';
import {selectCustomerWithActiveCart} from '../../../services/selectCustomerCart';
import {store} from '../../../store';
import {LuUser,LuShoppingBag,LuTruck,LuCheck} from 'react-icons/lu';
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  //Select,
  translateMessage,
} from "@delibrandev/utils";

import { searchCustomerInformation } from "../../../api/commander";
import { DeliveryOptions } from "./delivery-options";
import {
  setAlert,
  updateSelectedShippingMethod,
} from "../../../reducers/userConfigSlice";

const HorizontalSwitch = ({ shippingMethodOptions, selectedShippingMethodId, defaultShippingMethod, onChange, disabled }) => {
  const selectedOption =
    shippingMethodOptions.find((opt) => String(opt?.id) === String(selectedShippingMethodId)) ??
    defaultShippingMethod ??
    null;

  const handleSwitch = (opt) => {
    if (!disabled) onChange?.(opt);
  };

  const [open,setOpen]=useState(false);
  return <div className="tpvDeliveryControl"><button className="tpvHeaderChoice" type="button" disabled={disabled} onClick={()=>setOpen(true)}><LuShoppingBag aria-hidden="true"/><span><small>ENTREGA</small><strong>{selectedOption?.name||'Seleccionar'}</strong></span></button><input id="shippingMethod" type="hidden" value={selectedOption?.id??''} readOnly/>{open&&!disabled&&<TpvDialog title="Tipo de pedido" onClose={()=>setOpen(false)}><div className="tpvDialogBody tpvDeliveryChoices">{shippingMethodOptions.map(option=><button key={option.id} type="button" aria-pressed={String(selectedOption?.id)===String(option.id)} onClick={()=>{handleSwitch(option);setOpen(false);}}>{option.homeDeliveryIsActive?<LuTruck aria-hidden="true"/>:<LuShoppingBag aria-hidden="true"/>}<span><strong>{option.name}</strong><small>{option.homeDeliveryIsActive?'Reparto a domicilio':'El cliente recoge el pedido'}</small></span>{String(selectedOption?.id)===String(option.id)&&<LuCheck aria-hidden="true"/>}</button>)}</div></TpvDialog>}</div>;

};

export const OrderHeader = ({ setShowFloatPanel, setFloatPanelContent }) => {
  const dispatch = useDispatch();
  const clientSelected = useSelector((state) => state.aplicationConfig.userConfig.client);
  const order = useSelector((state) => state.aplicationConfig.userConfig.order);
  const isRecoveredCart = useSelector((state) => state.aplicationConfig.userConfig.request.isRecoveredCart);

  const shippingMethods = useSelector((state) => state.aplicationConfig.corporationData.pointMethods.shipping);
  const selectedShippingMethodId = useSelector((state) => state.aplicationConfig.userConfig.selectedShippingMethodId);

  const [searchMode, setSearchMode] = useState(false);
  const [, setSuggestions] = useState({});
  const selectionHandler=useRef(null);

  const isDefaultClient = useMemo(
    () =>
      String(clientSelected?.fullname || "")
        .trim()
        .toLowerCase() === "cliente contado",
    [clientSelected?.fullname],
  );
  const hasDeliveryClient = Boolean(clientSelected?.customerId) && !isDefaultClient;

  // Debounce para no llamar a la API en cada tecla

  // Generamos un id y un name para el Select
  // - También mostramos primero las de recogida en tienda
  const shippingMethodOptions = useMemo(() => {
    const list = Array.isArray(shippingMethods) ? shippingMethods : [];

    return list
      .map((method) => ({
        ...method,
        id: method.shippingMethodId,
        name: method.homeDeliveryIsActive
          ? method.nameHomeDelivery
          : method.storeDeliveryIsActive
            ? method.nameStoreDelivery
            : null,
      }))
      .sort((a, b) => (b.storeDeliveryIsActive ? 1 : 0) - (a.storeDeliveryIsActive ? 1 : 0));
  }, [shippingMethods]);

  const defaultShippingMethod = useMemo(() => {
    const shippingMethod = shippingMethodOptions.find((f) => f.nameHomeDelivery === order?.shippingMethod);
    if (shippingMethodOptions.length === 0) return null;

    // Al recuperar un pedido respetamos su método de envío en lugar de seleccionar
    // siempre la primera opción disponible.
    const recoveredShippingMethodId =
      order?.shippingMethodId ??
      order?.ShippingMethod?.shippingMethodId ??
      order?.shippingMethod?.shippingMethodId ??
      order?.shippingMethod?.id ??
      null;

    if (recoveredShippingMethodId != null) {
      const recoveredMethod = shippingMethodOptions.find(
        (method) => String(method?.id) === String(recoveredShippingMethodId),
      );
      if (recoveredMethod) return recoveredMethod;
    }

    return shippingMethod ? shippingMethod : shippingMethodOptions[0];
  }, [shippingMethodOptions, order?.shippingMethodId, order?.ShippingMethod, order?.shippingMethod]);

  const getShippingAddresses = (data, suggestions) => {
    const saved = data?.addresses?.shippingAddresses ?? [];
    // Si ya tiene direcciones guardadas, devuélvelas
    if (saved.length > 0) return saved;

    // Si no, saca direcciones desde pedidos del cliente
    const addressesFromOrders = (suggestions.orders ?? [])
      .filter((order) => order?.customerId === data?.customerId)
      .map((order) => order?.address)
      .filter((addr) => addr?.addressId); // solo válidas

    // Deduplicar por addressId (por si hay repetidas)
    const unique = Array.from(new Map(addressesFromOrders.map((a) => [a.addressId, a])).values());

    return unique;
  };

  const setDefaultClient = useCallback(async () => {
    const response=await searchCustomerInformation('Cliente Contado');
    const target=response?.error===false?response.data?.customer?.[0]:null;
    if(!target?.customerId)throw Error('No se pudo recuperar el cliente contado.');
    await selectionHandler.current(target,response.data);
  }, []);

  const handleSuggestion = useCallback(
    async (data, suggestions) => {
      const customer = { ...data, addresses: { ...data.addresses, shippingAddresses: getShippingAddresses(data, suggestions) } };
      const cart = await selectCustomerWithActiveCart({ customer, dispatch, getState: store.getState });
      const fullname = String(data?.fullname || "").trim().toLowerCase();
      if (cart) dispatch(setAlert(translateMessage("Se ha recuperado la cesta activa del cliente")));

      // Si no es "cliente contado", abrimos panel de opciones de entrega
      if (fullname !== "cliente contado" && shippingMethodOptions.find(method=>String(method.id)===String(selectedShippingMethodId))?.homeDeliveryIsActive) {
        setShowFloatPanel(true);
        setFloatPanelContent(
          <DeliveryOptions
            clientData={data}
            setShowFloatPanel={setShowFloatPanel}
            setDefaultClient={setDefaultClient}
          />,
        );
      }

      setSearchMode(false);
      setSuggestions({});
    },
    [dispatch, setFloatPanelContent, setShowFloatPanel, shippingMethodOptions, selectedShippingMethodId, setDefaultClient],
  );

  selectionHandler.current=handleSuggestion;

  useEffect(() => {
    if (clientSelected?.customerId || order?.orderId || isRecoveredCart) return;
    let active = true;
    (async () => {
      try {
        const response = await searchCustomerInformation("Cliente Contado");
        const customer = response?.error === false ? response.data?.customer?.[0] : null;
        if (!active || store.getState().aplicationConfig.userConfig.client?.customerId) return;
        if (!customer?.customerId) throw Error("No se pudo recuperar el cliente contado.");
        await selectCustomerWithActiveCart({ customer, dispatch, getState: store.getState, initialize: true });
      } catch (error) {
        if (active) dispatch(setAlert({ called: true, type: "error", title: "Revisa el cliente", message: error.message }));
      }
    })();
    return () => { active = false; };
  }, [clientSelected?.customerId, dispatch, isRecoveredCart, order?.orderId]);

  const handleShippingMethodChange = useCallback(
    (method) => {
      dispatch(updateSelectedShippingMethod(method?.id ?? null));

      if (method?.homeDeliveryIsActive && !hasDeliveryClient) {
        setSearchMode(true);
      }
    },
    [dispatch, hasDeliveryClient],
  );

  useEffect(() => {
    if (!defaultShippingMethod) return;

    const selectedMethodExists = shippingMethodOptions.some(
      (method) => String(method?.id) === String(selectedShippingMethodId),
    );

    const recoveredShippingMethodId =
      order?.shippingMethodId ??
      order?.ShippingMethod?.shippingMethodId ??
      order?.shippingMethod?.shippingMethodId ??
      order?.shippingMethod?.id ??
      null;

    const shouldRestoreRecoveredMethod =
      Boolean(order?.orderId) &&
      recoveredShippingMethodId != null &&
      String(selectedShippingMethodId) !== String(defaultShippingMethod.id);

    // Solo aplicamos el valor por defecto al inicializar o al recuperar un pedido.
    // Antes este efecto se ejecutaba de nuevo cuando cambiaba el cliente y podía
    // sobrescribir "Domicilio" en Redux aunque el switch siguiera mostrándolo.
    if (!selectedMethodExists || shouldRestoreRecoveredMethod) {
      dispatch(updateSelectedShippingMethod(defaultShippingMethod.id));

      if (defaultShippingMethod?.homeDeliveryIsActive && !hasDeliveryClient) {
        setSearchMode(true);
      }
    }
  }, [
    defaultShippingMethod,
    dispatch,
    hasDeliveryClient,
    order?.ShippingMethod,
    order?.orderId,
    order?.shippingMethod,
    order?.shippingMethodId,
    selectedShippingMethodId,
    shippingMethodOptions,
  ]);


  return <div className="order-commander-header tpvReferenceHeader"><button type="button" className="tpvHeaderChoice" disabled={Boolean(order?.orderId)} onClick={()=>setSearchMode(true)}><LuUser aria-hidden="true"/><span><small>CLIENTE</small><strong>{clientSelected?.fullname||'Cliente contado'}</strong></span></button><HorizontalSwitch shippingMethodOptions={shippingMethodOptions} selectedShippingMethodId={selectedShippingMethodId} defaultShippingMethod={defaultShippingMethod} onChange={handleShippingMethodChange} disabled={Boolean(order?.orderId)}/>{searchMode&&<CustomerPicker isDefault={isDefaultClient} selected={clientSelected} onSelect={data=>handleSuggestion(data,{})} onDefault={setDefaultClient} onError={message=>dispatch(setAlert({called:true,type:'error',title:'Revisa el cliente',message}))} onClose={()=>setSearchMode(false)}/>}</div>;
};
